import { wishlistsStore } from 'src/stores';

export const isInWishList = (race: { id: number }) => {
  return wishlistsStore.values.some((item) => item.id === race.id);
};
